import { StatisticsView } from '../../features/statistics/StatisticsView';

/** Statistics — served at both /statistics and /stats. */
export default function StatisticsPage() {
  return <StatisticsView />;
}
